import { useCurrency } from "@/hooks/useCurrency";
import { Globe } from "lucide-react";

const LABEL = { usd: "USD", nzd: "NZD", aud: "AUD" };

/**
 * Compact currency selector for the Navbar. Hidden for Australian visitors
 * (locked to AUD inc GST); everyone else can flip between USD and NZD.
 */
export function CurrencySelector({ className = "" }) {
  const { currency, setCurrency, locked, options } = useCurrency();
  if (locked || options.length < 2) return null;
  return (
    <div className={`relative inline-flex items-center ${className}`} data-testid="currency-selector">
      <Globe className="w-3.5 h-3.5 text-white/40 absolute left-2 pointer-events-none" />
      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        className="appearance-none bg-white/[0.03] hover:bg-white/[0.06] ring-1 ring-white/10 rounded-full py-1.5 pl-7 pr-3 text-xs text-white/80 font-medium cursor-pointer outline-none transition-colors"
        aria-label="Select currency"
        data-testid="currency-select"
      >
        {options.map((c) => (
          <option key={c} value={c} className="bg-[#0a0a1a] text-white">{LABEL[c]}</option>
        ))}
      </select>
    </div>
  );
}
